var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myshipment"},[_vm._m(0),_c('router-view')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"moduletitle"}},[_c('h2',[_vm._v("My Shipment")])])}]

export { render, staticRenderFns }